import { graphql } from "react-apollo";
import { updateTemplate } from './queries';
import SaveButton from '../../components/SaveButton';

export default graphql(updateTemplate, { options: { refetchQueries: ['Templates'] } })(SaveButton)
